import { useBreadcrumbParts } from './Breadcrumbs.hooks'
import { BreadcrumbsBase } from './BreadcrumbsBase'

export const Breadcrumbs = () => {
  const breadcrumbParts = useBreadcrumbParts()

  return <BreadcrumbsBase breadcrumbParts={breadcrumbParts} />
}
